/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

export enum TSReportType {
    AUSZAHLUNG_KANTON = <any>'AUSZAHLUNG_KANTON',
    AUSZAHLUNG = <any>'AUSZAHLUNG',
    SCHADEN = <any>'SCHADEN',
    ALLE = <any>'ALLE'
}

export function getTSReportTypeValues(): Array<TSReportType> {
    return [
        TSReportType.AUSZAHLUNG_KANTON,
        TSReportType.AUSZAHLUNG,
        TSReportType.SCHADEN,
        TSReportType.ALLE,
    ];
}

export function getTSReportTypeValuesWhitoutKanton(): Array<TSReportType> {
    return [
        TSReportType.AUSZAHLUNG,
        TSReportType.SCHADEN,
        TSReportType.ALLE,
    ];
}

export let displayAuszahlungsDatumMap: Map<TSReportType, boolean> = new Map<TSReportType, boolean>()
    .set(TSReportType.AUSZAHLUNG_KANTON, true)
    .set(TSReportType.AUSZAHLUNG, true)
    .set(TSReportType.SCHADEN, false)
    .set(TSReportType.ALLE, false);

export let displayEreignisDatumMap: Map<TSReportType, boolean> = new Map<TSReportType, boolean>()
    .set(TSReportType.AUSZAHLUNG_KANTON, true)
    .set(TSReportType.AUSZAHLUNG, true)
    .set(TSReportType.SCHADEN, true)
    .set(TSReportType.ALLE, true);

export let displayGesuchsDatumMap: Map<TSReportType, boolean> = new Map<TSReportType, boolean>()
    .set(TSReportType.AUSZAHLUNG_KANTON, true)
    .set(TSReportType.AUSZAHLUNG, true)
    .set(TSReportType.SCHADEN, true)
    .set(TSReportType.ALLE, true);






// WEBPACK FOOTER //
// ./src/app/models/enums/TSReportType.ts